import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

async function main() {
  if (!String.format) {
    String.format = function(format) {
      var args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function(match, number) { 
        return typeof args[number] != 'undefined'
          ? args[number] 
          : match
        ;
      });
    };
  }
  const response = await fetch('problems.json');
  const body = await response;
  if (response.status !== 200) {
    throw Error(body.message) 
  }
  const problems = await body.json();
  ReactDOM.render(<App problems={problems}/>, document.getElementById('root'));
}

main();